module.exports = __webpack_public_path__ + "static/media/inviteSuccess.73a021a1.png";